/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountEphemeralCredentialsForAwsAssumeRoleProtocol extends models.ServiceAccountEphemeralCredentialsBase {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountEphemeralCredentialsForAwsAssumeRoleProtocol");
    }

    getFixupPrototypeFunction() { return ServiceAccountEphemeralCredentialsForAwsAssumeRoleProtocol.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountEphemeralCredentialsForAwsAssumeRoleProtocol>): ServiceAccountEphemeralCredentialsForAwsAssumeRoleProtocol {
        let obj = Object.assign(new ServiceAccountEphemeralCredentialsForAwsAssumeRoleProtocol(), model);
        ServiceAccountEphemeralCredentialsForAwsAssumeRoleProtocol.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountEphemeralCredentialsForAwsAssumeRoleProtocol>): ServiceAccountEphemeralCredentialsForAwsAssumeRoleProtocol {
        if (!model) return null;
        return ServiceAccountEphemeralCredentialsForAwsAssumeRoleProtocol.newInstance(<ServiceAccountEphemeralCredentialsForAwsAssumeRoleProtocol> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountEphemeralCredentialsForAwsAssumeRoleProtocol) {
        if (!obj) return;

        models.ServiceAccountEphemeralCredentialsForAwsAssumeRoleProtocol.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountEphemeralCredentialsForAwsAssumeRoleProtocol): boolean {
        if (models.ServiceAccountEphemeralCredentialsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountEphemeralCredentialsForAwsAssumeRoleProtocol.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Access Key Id
     */
    access_key: string;

    /**
     * Secret Access Key Id
     */
    secret_key: string;

    /**
     * Session Token
     */
    session_token: string;

}
